export enum DirectoryTemplateId {
    COMMUNITY_DIRECTORY = "a39b9fa9-d61c-4ce8-af85-a80100a8bd04",
    MARKETPLACE = "5c474a39-9a5b-48e7-8e59-abea00826451",
    HOME_CARE = "17aa4b91-19d9-405f-a5a4-a5ed00f373c8",
    CARE_HOMES = "e33a53ba-0e9c-4772-80f8-a5ed00f38f34"
}
